import React from "react";
import style from "./MultipleSelections.module.scss";
import { DbPulldownSearchForm } from "../templates/output_suggests/DbPulldownSearchForm";
import { useTranslation } from "react-i18next";

type Props = {
  selections: string[];
  fetchSelections: (value: string) => void;
  selectedValues: string[];
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isMore?: boolean;
  fetchMore?: () => void;
  position?: {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
  };
};

const MultipleSelections = ({
  selections,
  fetchSelections,
  selectedValues,
  handleChange,
  isMore = false,
  fetchMore,
  position,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={style.Container}
      style={{
        position: "absolute",
        zIndex: 2,
        ...(position && {
          top: position.top ? `${position.top}px` : undefined,
          bottom: position.bottom ? `${position.bottom}px` : undefined,
          left: position.left ? `${position.left}px` : undefined,
          right: position.right ? `${position.right}px` : undefined,
        }),
      }}
    >
      <DbPulldownSearchForm
        onSearchList={(value) => fetchSelections(value)}
        setSelectionSearchingFlg={(value) => value}
      />
      <div style={{ maxHeight: 250, overflow: "auto" }}>
        <ul className={style.Selections}>
          {selections.map((item) => (
            <li className={style.SelectionsItem} key={item}>
              <label className={style.SelectionsCheckBox}>
                <input type="checkbox" checked={selectedValues.includes(item)} onChange={handleChange} value={item} />
                <div>
                  <span>{item}</span>
                </div>
              </label>
            </li>
          ))}
          {isMore && (
            <li className={style.SelectionsItemMore} onClick={fetchMore}>
              {t("MultipleSelections.さらに読み込む")}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MultipleSelections;
